import { combineReducers } from '@reduxjs/toolkit';
import { contactSlice } from './contact';
import { layoutSlice } from './layout';

export const rootReducer = combineReducers({
  contactReducer: contactSlice.reducer,
  layoutReducer: layoutSlice.reducer,
});
